import axios from 'axios';
import {backendHost} from '../../../../store/config';

const postUpdateGive = (params) => {
    return axios.post(`${backendHost}/api/admin/jackpot/give/update`, params);
};

export {
    postUpdateGive
}